export default __webpack_public_path__ + "static/media/DougWheeler.315c6cce.jpeg";